// intentionally not included in the barrel export so that importing this
// (extremely lightweight) functionality doesn't come with hangers-on

/**
 * Proper Manifests must have a tracking number that is suffixed by a three-letter
 * code representing the EPA-approved registered printer:
 * https://www.epa.gov/hwgenerators/approved-registered-printers-epas-manifest-registry
 */

export const MTN_SUFFIX_LIST = [
  "CLE",
  "PSC",
  "SKS",
  "VES",
  "GRR",
  "DAT",
  "GBF",
  "WAS",
  "JJK",
  "FLE",
] as const;

// using [0-9] instead of \d because
//   a) existing SQL interpolation use does that already
//   b) the string-into-regex thing we're doing here means that \d would read
//      as a special string character, and the backslash would need to be escaped
//      and it would just be less readable
export const MTN_REGEX_AS_STRING = `^[0-9]{9}(${MTN_SUFFIX_LIST.join("|")})$`;

export const MTN_REGEX = new RegExp(MTN_REGEX_AS_STRING);

export type MtnSuffix = (typeof MTN_SUFFIX_LIST)[number];

export const MTN_SUFFIXES: ReadonlySet<MtnSuffix> = new Set(MTN_SUFFIX_LIST);

export function isMtnSuffix(value: unknown): value is MtnSuffix {
  // the `as any` here is fine - at runtime the type doesn't matter; anything
  // that is the wrong type will just not be present in the set and return false
  return MTN_SUFFIXES.has(value as any);
}

export function isUniformManifestTrackingNumber(value: string): boolean {
  return MTN_REGEX.test(value);
}
